import { isNull } from 'lodash/fp';
import React, { useEffect, useMemo } from 'react';
import { RouteComponentProps } from 'react-router';

import { useAppDispatch, useAppSelector } from '../../../hooks/react-redux';
import { useFetchStarted } from '../../../hooks/useFetchStarted';
import { fetchAllDropdownListsStarted } from '../../admin/dropdown-lists/store';
import { fetchAllEntitiesStarted } from '../../admin/entity/store';
import { PageLoadingDots } from '../../shared/loading-dots/PageLoadingDots';
import { OpinionReportSelect } from './OpinionReportSelect';
import { OpinionReportsWizard } from './OpinionReportsWizard';
import { OpinionReportTemplates } from './OpinionReportTemplates';
import styles from './Reports.module.scss';
import { ReportPage, fetchAllReportTemplatesStarted, getIsFetchingTemplates, getReportPage, getSelectedTemplate, resetReport, setReportPage } from './store';

export interface OpinionReportRouteParams {
    templateId: string | undefined;
}

export const OpinionReports: React.FC<RouteComponentProps<OpinionReportRouteParams>> = ({ match: { url, params } }) => {
    const dispatch = useAppDispatch();
    const reportPage = useAppSelector(getReportPage);
    const selectedTemplate = useAppSelector(getSelectedTemplate);
    const isFetching = useAppSelector(getIsFetchingTemplates);

    useFetchStarted([fetchAllEntitiesStarted(), fetchAllReportTemplatesStarted(), fetchAllDropdownListsStarted()]);

    const pageContent = useMemo(() => {
        if (isFetching && url && url.includes('templates')) {
            return <PageLoadingDots />;
        }
        switch (reportPage) {
            case ReportPage.SELECT:
            default:
                return <OpinionReportSelect />;
            case ReportPage.WIZARD:
                return <OpinionReportsWizard />;
            case ReportPage.TEMPLATES:
                return <OpinionReportTemplates />;
        }
    }, [reportPage, isFetching, url]);

    useEffect(() => {
        if (isNull(selectedTemplate) && url) {
            if (url.includes('templates')) {
                dispatch(setReportPage(ReportPage.TEMPLATES, params.templateId));
            }
        }
    }, [selectedTemplate, dispatch, url, reportPage, params.templateId]);

    useEffect(() => () => {
        dispatch(resetReport(ReportPage.SELECT));
    }, [dispatch]);

    return (
        <div data-testid='opinion-reporting-wrapper' className={styles.reportsWrapper}>
            {pageContent}
        </div>
    );
};
